import { Spin } from 'antd'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import Select from 'components/Select'
import { FormItem, StyledInput } from 'components/UIComponents/FormStyles'
import CloseIcon from 'components/icons/CloseIcon'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { EmptySpanElement } from '../../../../../../components/UIComponents/CommonStyledComponent'
import { isReturnBoolean } from '../../../../../../utils/rolecreationHelpers'
import CommonSkillAndOr from './CommonSkillAndOR'
import { ButtonRowDiv, StyledDashedBorderBox } from './Styles'

const CustomLabel = styled(Label)`
  margin: 1em;
  border: 1px solid gainsboro;
  border-radius: 10px;
  padding: 1em 1.5em;
  height: 3.5em;
  cursor: pointer;
  display: flex;
  align-items: center;
  letter-spacing: 0.1em;
  width: 9em;
  justify-content: center;
  pointer-events: ${props => (props?.pointerEvent ? 'none' : 'unset')};
  background-color: ${props => (props.disabled ? '#3249d7' : '#ffff')};
  color: ${props =>
    props.disabled ? '#ffff !important' : 'rgb(112, 112, 112)'};
  justify-content: center;
  ${
    '' /* &:hover {
    background-color: #3249d7;
    color: #ffff !important;
  }
  &:focus {
    background-color: #3249d7;
    color: #ffff !important;
  } */
  }
`
const MandatorySkills = ({
  singleRoleData,
  roleFormData,
  setRoleFormData,
  isEditRoleOnView,
  listOfAndOrSkills,
  onChangeHandler,
  setSkillSearch,
  handleDropdownVisibleChange,
  onChangeMandatorySkills,
  mandatorySkillCount,
  roleForm,
  isFieldsMandatory,
  skillLoading,
  mandatoryTypeError,
  skillsSetOpen,
  setSkillsSetOpen,
  notFoundedSecondarySkills,
  notFoundedMandatorySkills,
  skillSearch,
}) => {
  const renderTag = option => {
    return (
      <div
        className="ant-select-selection-overflow-item"
        style={{
          position: 'relative',
          opacity: 1,
          display: 'flex',
        }}
      >
        <span className="ant-select-selection-item ant-select-selection-item-disabled">
          <span className="ant-select-selection-item-content">
            {option?.label}
          </span>
          {!option?.disabled && option?.closable && (
            <EmptySpanElement onClick={option?.onClose}>
              <CloseIcon />
            </EmptySpanElement>
          )}
        </span>
      </div>
    )
  }

  const handleOpenSkillSet = () => {
    setSkillsSetOpen(true)
  }

  useEffect(() => {
    if (roleFormData?.mandatorySkills?.mandatory?.length > 0) {
      handleOpenSkillSet()
    }
  }, [[roleFormData?.mandatorySkills]])
  return (
    <>
      {skillLoading ? (
        <Spin />
      ) : (
        <div>
          <div>
            <Label>Mandatory Skills</Label>

            <StyledDashedBorderBox>
              <div>
                <ButtonRowDiv>
                  <CustomLabel
                    disabled={
                      roleFormData?.mandatorySkills?.primary?.type === 'AND'
                    }
                    onClick={() => {
                      if (!isReturnBoolean(roleFormData?.roleStatus,undefined,roleFormData?.republishedDate)) {
                        onChangeMandatorySkills('AND', 'primary', 'type')
                      }
                    }}
                    pointerEvent={
                      roleFormData?.mandatorySkills?.primary?.skills?.length ===
                      0
                    }
                  >
                    AND
                  </CustomLabel>
                  <CustomLabel
                    disabled={
                      roleFormData?.mandatorySkills?.primary?.type === 'OR'
                    }
                    onClick={() => {
                      if (!isReturnBoolean(roleFormData?.roleStatus,undefined,roleFormData?.republishedDate)) {
                        onChangeMandatorySkills('OR', 'primary', 'type')
                      }
                    }}
                    pointerEvent={
                      roleFormData?.mandatorySkills?.primary?.skills?.length ===
                      0
                    }
                  >
                    OR
                  </CustomLabel>
                </ButtonRowDiv>
                <div
                  style={{
                    fontSize: '14px',
                    color: 'red',
                    fontWeight: '400',
                  }}
                >
                  {mandatoryTypeError && isFieldsMandatory
                    ? 'Please select the skill type'
                    : ''}
                </div>
                <Label paddingTop="6px" paddingBottom="6px">
                  Skill Set 1
                </Label>
              </div>

              <CommonSkillAndOr
                AndORname={['mandatorySkills', 'primary', 'type']}
                skillName={['mandatorySkills', 'primary', 'skills']}
                handleSelectChange={(value, newArr) => {
                  onChangeMandatorySkills(value, 'primary', 'skills', newArr)
                  setSkillSearch('')
                }}
                searchValue={skillSearch}
                OptionData={listOfAndOrSkills?.filter(
                  skill =>
                    !roleFormData?.optionalSkills?.includes(skill?.id) &&
                    !roleFormData?.mandatorySkills?.mandatory?.includes(
                      skill?.id
                    ) &&
                    !roleFormData?.mandatorySkills?.otherSkills?.some(
                      otherSkill => otherSkill?.skills?.includes(skill?.id)
                    )
                )}
                onSearch={value => setSkillSearch(value)}
                value={
                  singleRoleData?.mandatorySkills?.primary ?? {
                    type: '',
                    skills: [],
                  }
                }
                handleDropdownVisibleChange={handleDropdownVisibleChange}
                isEditRoleOnView={isEditRoleOnView}
                lastValue={
                  roleFormData?.mandatorySkills?.primary?.skills?.[
                    (roleFormData?.mandatorySkills?.primary?.skills?.length ??
                      0) - 1
                  ] ?? ''
                }
                symbol={roleFormData?.mandatorySkills?.primary?.type ?? '_'}
                selectedLength={
                  roleFormData?.mandatorySkills?.primary?.skills?.length ?? 0
                }
                mandatorySkillCount={mandatorySkillCount}
                disabled={isEditRoleOnView}
                required={true}
                key={'primary'}
                isFieldsMandatory={isFieldsMandatory}
                selectFieldDisabled={isReturnBoolean(roleFormData?.roleStatus,undefined,roleFormData?.republishedDate)}
              />
              {notFoundedMandatorySkills?.length > 0 && (
                <div
                  style={{
                    color: 'red',
                    marginTop: '-24px',
                    marginBottom: '10px',
                    wordBreak: 'break-all',
                  }}
                >
                  No data matched for {notFoundedMandatorySkills.join(', ')}
                </div>
              )}
              <div>
                <div>
                  <Label paddingTop="6px" paddingBottom="6px">
                    Skill Set 2
                  </Label>

                  <br />

                  <FormItem
                    name={['mandatorySkills', 'mandatory']}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (
                            (roleFormData?.mandatorySkills?.mandatory?.length ??
                              0) > 15
                          ) {
                            return Promise.reject(
                              new Error(`Skill should not exceed 15 skills`)
                            )
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}
                  >
                    <Select
                      showArrow={true}
                      showSearch={true}
                      OptionData={listOfAndOrSkills?.filter(
                        skill =>
                          !roleFormData?.optionalSkills?.includes(skill?.id) &&
                          !roleFormData?.mandatorySkills?.primary?.skills?.includes(
                            skill?.id
                          ) &&
                          !roleFormData?.mandatorySkills?.otherSkills?.some(
                            otherSkill =>
                              otherSkill?.skills?.includes(skill?.id)
                          )
                      )}
                      label=""
                      valueParam="id"
                      placeholder="Select Skills"
                      mode="multiple"
                      onChange={(value, newArr) =>
                        onChangeMandatorySkills(
                          value,
                          'mandatory',
                          'skills',
                          newArr
                        )
                      }
                      onSearch={value => setSkillSearch(value)}
                      filterOption={false}
                      customOptions={isEditRoleOnView}
                      selectedOptions={
                        singleRoleData?.mandatorySkills?.mandatory ?? []
                      }
                      onDropdownVisibleChange={handleDropdownVisibleChange}
                      tagRender={option => renderTag(option)}
                      autoClearSearchValue={true}
                      allowClear={!isEditRoleOnView}
                      disabled={isReturnBoolean(roleFormData?.roleStatus,undefined,roleFormData?.republishedDate)}
                    />
                  </FormItem>
                  {notFoundedSecondarySkills?.length > 0 && (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '8px',
                        wordBreak: 'break-all',
                      }}
                    >
                      No data matched for {notFoundedSecondarySkills.join(', ')}
                    </div>
                  )}
                  {roleFormData?.mandatorySkills?.mandatory?.length ? (
                    <Flex right>
                      <Label>
                        {roleFormData?.mandatorySkills?.mandatory?.length}/
                        {mandatorySkillCount}
                      </Label>
                    </Flex>
                  ) : null}
                </div>
                <div>
                  <br />
                  <Label paddingTop="6px" paddingBottom="6px">
                    No. of skill set 2 is required
                  </Label>

                  <br />

                  <StyledInput
                    style={{ borderRadius: '8px' }}
                    disabled={!roleFormData?.mandatorySkills?.mandatory?.length}
                    type="number"
                    width="70%"
                    name={['mandatorySkills', 'mandatoryCount']}
                    rules={[
                      {
                        required: isFieldsMandatory,
                        message: '',
                      },
                      {
                        validator: (_, value) => {
                          let skillsLength =
                            roleFormData?.mandatorySkills?.mandatory?.length ??
                            0
                          if (!Number.isInteger(Number(value))) {
                            return Promise.reject(
                              new Error('Please enter a natural number.')
                            )
                          }
                          if (
                            (skillsLength < Number(value) ||
                              Number(value) <= 0) &&
                            (value <= 0 || value > skillsLength) &&
                            skillsLength > 0 &&
                            isFieldsMandatory
                          ) {
                            let errorMessage = ''
                            if (skillsLength == 1) {
                              errorMessage = `Must be equal to 1 !`
                            } else if (skillsLength == 0) {
                              errorMessage = `No.of Skills must be greater than 0!`
                            } else {
                              errorMessage = `Must be smaller than or equal to ${skillsLength} and not 0 !`
                            }
                            return Promise.reject(new Error(errorMessage))
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}
                    placeholder="Type Number"
                    defaultValue={
                      roleFormData?.mandatorySkills?.mandatoryCount > 0
                        ? roleFormData?.mandatorySkills?.mandatoryCount || 0
                        : 0
                    }
                    onChange={({ target }) => {
                      const intValue = target.value.replace(/\D/g, '') // Allow only digits (no decimals)
                      setRoleFormData({
                        ...roleFormData,
                        mandatorySkills: {
                          ...(roleFormData.mandatorySkills
                            ? roleFormData.mandatorySkills
                            : {}),
                          mandatoryCount: intValue ? Number(intValue) : '',
                        },
                      })
                      onChangeMandatorySkills(
                        intValue,
                        'mandatoryCount',
                        'skills',
                      )
                    }}
                  />
                  {roleFormData?.mandatorySkills?.mandatory?.length > 0 && (
                    <Flex right>
                      <Label>
                        {roleFormData?.mandatorySkills?.mandatoryCount || 0}/
                        {roleFormData?.mandatorySkills?.mandatory?.length}
                      </Label>
                    </Flex>
                  )}
                </div>
              </div>
            </StyledDashedBorderBox>
          </div>
        </div>
      )}
    </>
  )
}
export default MandatorySkills
